import { formatRelativeTime } from "@/utils/dateUtils";

const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

// A few audit actions read badly under the generic underscore-to-title rule.
// `no_show` is an interview outcome, and the product calls it "Not Completed"
// everywhere else — this timeline has to say the same thing. The document
// actions are compliance's, and on this timeline "Upload Document" would read
// as a resume upload.
const ACTION_LABELS = {
  no_show: "Not Completed",
  UPLOAD_DOCUMENT: "Upload Compliance Document",
  APPROVE_DOCUMENT: "Approve Compliance Document",
  REJECT_DOCUMENT: "Reject Compliance Document",
  RE_REQUEST_DOCUMENT: "Re-request Compliance Document",
};

const formatAction = (action) => ACTION_LABELS[action] || action.split("_").map(capitalize).join(" ");

/**
 * Kept as a name this tab already imports; the clock itself is
 * `utils/dateUtils.js::formatRelativeTime`, shared with the Notes tab so the
 * two timelines beside each other cannot disagree.
 *
 * What used to be here wrapped the value in `toZonedTime(value, <the browser's
 * own zone>)` before measuring it — an identity, on every machine — and blew up
 * on a row with no timestamp.
 */
const formatTimeAgo = (dateString) => formatRelativeTime(dateString);

export { capitalize, formatAction, formatTimeAgo };
